<template>
  <div class="promotion-wrap">
    <img src="../../assets/image/Zuzuche_Pro/zzc_1.png"/>
    <div class="applyPart">
      <div class="item item-city">
        <input type="text" v-model="city" placeholder="所在城市" maxlength="18" @blur="blur"/>
      </div>
      <div class="item item-carType">
        <input type="text" placeholder="请选择车型" v-model="carModel" readonly>
        <select v-model="carModel" @click="carChange">
          <option v-for="carname in carModelListNew">{{carname}}</option>
        </select>
        <img src="../../assets/image/Zuzuche_Pro/arrow.png">
      </div>
      <div class="item item-mobile">
        <input type="tel" v-model="mobile" placeholder="请输入手机号" maxlength="11" @blur="blur"/>
      </div>
      <div class="item item-check">
        <input type="number" v-model="vCode" placeholder="请输入验证码" maxlength="6" @blur="blur" @input="vCodeMaxLength"/>
        <button ref="code" v-html="vCodeStr" @click="getCode"></button>
      </div>
      <button @click="submit">提交申请</button>
    </div>
    <div class="video">
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </div>
    <img src="../../assets/image/Zuzuche_Pro/zzc_3.png"/>
    <div class="applyPart applyPart-last">
      <div class="label">
        <img src="../../assets/image/Zuzuche_Pro/zzc_4.png"/>
      </div>
      <div class="item item-city">
        <input type="text" v-model="city" placeholder="所在城市" maxlength="18" @blur="blur"/>
      </div>
      <div class="item item-carType">
        <input type="text" placeholder="请选择车型" v-model="carModel" readonly>
        <select v-model="carModel" @click="carChange">
          <option v-for="carname in carModelListNew">{{carname}}</option>
        </select>
        <img src="../../assets/image/Zuzuche_Pro/arrow.png">
      </div>
      <div class="item item-mobile">
        <input type="tel" v-model="mobile" placeholder="请输入手机号" maxlength="11" @blur="blur"/>
      </div>
      <div class="item item-check">
        <input type="number" v-model="vCode" placeholder="请输入验证码" maxlength="6" @blur="blur" @input="vCodeMaxLength"/>
        <button ref="code" v-html="vCodeStr" @click="getCode"></button>
      </div>
      <button @click="submit">提交申请</button>
    </div>

    <img class="page-img-item2" src="../../assets/image/Zuzuche_Pro/zzc_5.png"/>

    <img class="page-img-item2" src="../../assets/image/Zuzuche_Pro/zzc_6.png"/>

    <img class="page-img-item2" src="../../assets/image/Zuzuche_Pro/zzc_7.png"/>

    <img class="page-img-item3" src="../../assets/image/Zuzuche_Pro/zzc_8.png"/>
  </div>
</template>

<script>
  import common from '../../utils/common'
  import constants from '../../utils/constants'
  import qs from 'qs'

  export default {
    name: "TslPro",
    data() {
      return {
        city: null,
        carModel: null,
        mobile: null,
        vCode: null,
        carModelListNew: ['Model 3', 'Model S', 'Model X'],
        vCodeStr: '获取验证码',
        leadsChannel: '促销-202004-TSL',
        sourceType: '99',
        firstOpen: true,
        playerOptions: {
          //播放速度
          playbackRates: [1.0],
          //如果true,浏览器准备好时开始回放。
          autoplay: true,
          // 默认情况下将会消除任何音频。
          muted: false,
          // 导致视频一结束就重新开始。
          loop: true,
          // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          preload: 'auto',
          language: 'zh-CN',
          // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          aspectRatio: '1:1',
          // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          fluid: true,
          sources: [{
            //类型
            type: "video/mp4",
            //url地址
            src: 'http://mkt.chejia.net.cn/share/tesla.MP4'
          }],
          //你的封面地址
          poster: 'http://mkt.chejia.net.cn/share/video_banner.png',
          //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            //全屏按钮
            fullscreenToggle: true
          }
        }
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      const that = this
      that.$nextTick(function () {
        /* 记录促销页面打开时间 */
        that.$axios.post('/marketing/initInfoInsert', qs.stringify({'leadsChannel': that.leadsChannel})).then(function (res) {
          return
        }).catch(function (error) {
          return
        })
        common.wxShare(that, constants.TESLA_SHAREINFO)
      });
    },
    methods: {
      blur() {
        common.blurPageScroll()
      },

      carChange(){
        if(this.firstOpen) {
          this.carModel = this.carModelListNew[0]
          this.firstOpen = false
        }
      },

      // vue input type 为number时用maxlength无效
      //  此方法限制验证码输入位数
      vCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
      },

      // 获取验证码
      getCode(e) {
        const vm = this
        common.getVCodeMarketing(vm, e)
      },

      submit() {
        const that = this
        that.city = common.trimAll(that.city)
        that.mobile = common.trimAll(that.mobile)
        that.vCode = common.trimAll(that.vCode)
        if (common.isEmpty(that.city)) {
          common.tipToast("请输入所在城市")
          return
        }
        if (common.isEmpty(that.carModel)) {
          common.tipToast("请选择车型")
          return
        }
        if (common.isEmpty(that.mobile)) {
          common.tipToast("请输入手机号码")
          return
        }
        if (!common.checkMobile(that.mobile)) {
          common.tipToast("手机号码格式不正确")
          return
        }
        if (common.isEmpty(that.vCode)) {
          common.tipToast("请输入手机号验证码")
          return
        }

        that.$axios.post('/marketing/createOrder', qs.stringify({
          'city': that.city,
          'carModel': that.carModel,
          'mobile': that.mobile,
          'code': that.vCode,
          'leadsChannel': that.leadsChannel,
          'sourceType': that.sourceType
        })).then(function (res) {
          clearInterval(common.VCodeObj.timer); // 清除js定时器
          that.city = null
          that.carModel = null
          that.mobile = null
          that.vCode = null
          that.vCodeStr = '获取验证码',
          common.VCodeObj.timeCount = 60
          common.VCodeObj.timer = null
          that.$refs.code.disabled = false
          common.tipToast("信息提交成功")
          return
        }).catch(function (err) {
          that.vCode = null
          common.tipToast(err.data.msg)
          return
        })
      }
    },
  }
</script>

<style scoped>
  .promotion-wrap {
    margin: 0 auto;
    max-width: 7.50rem;
    min-width: 3.20rem;
    position: relative;
    font-size: 0;
    width: 100%;
    text-align: center;
    background-color: #000;
  }

  .promotion-wrap > img {
    width: 100%
  }

  .promotion-wrap > .page-img-item2 {
    width: 6.70rem;
    margin-top: 0.4rem;
  }

  .promotion-wrap > img:last-child {
    margin: 0 auto;
    padding: 0.7rem 0;
    width: 5.65rem
  }

  .promotion-wrap > .video {
    margin: 0 auto;
    margin-bottom: 0.68rem;
    width: 6.7rem;
  }
  .applyPart {
    margin: 0.44rem auto;
    margin-bottom: 0.6rem;
    padding-top: 0.35rem;
    padding-bottom: 0.4rem;
    width: 6.70rem;
    background-image: url("../../assets/image/Zuzuche_Pro/zzc_2.png");
    background-size: cover;
    background-repeat: no-repeat;
  }

  .applyPart-last{
    padding-top: 0.46rem;
    margin: 0 auto;
    padding-bottom: 0.56rem;
  }

  .applyPart-last > .label {
    margin: 0 auto;
    margin-bottom: 0.16rem;
    width: 2.43rem;
    font-size: 0;
  }

  .applyPart-last > .label > img  {
    width: 100%;
  }

  .applyPart > button {
    margin-top: 0.80rem;
    width: 5.98rem;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.32rem;
    color: #fff;
    border-width: 0;
    background-image: linear-gradient(270deg, #5493F6 0%, #1818CD 100%);
    outline: none;
  }

  .applyPart-last > button {
    margin-top: 1.04rem;
  }

  .item {
    border-bottom: 0.01rem solid rgba(227,227,227,0.27);
    position: relative;
    margin: 0 auto;
    margin-top: 0.35rem;
    width: 5.98rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .item > input {
    width: 100%;
    height: 0.9rem;
    line-height: 0.36rem;
    border-width: 0;
    outline: 0;
    font-size: 0.30rem;
    color: #fff;
    background-color: rgba(255, 255, 255, 0);
  }

  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #b2b1b1;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #b2b1b1;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #b2b1b1;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #b2b1b1;
  }

  .item-carType {
    height: 0.9rem;
  }

  .item-carType > input {
    position: absolute;
    height: 0.88rem;
    pointer-events: none;
    z-index: 2;
  }

  .item > select {
    display: block;
    width: 100%;
    height: 0.88rem;
    font-size: 0.32rem;
    background-color: rgba(255, 255, 255, 0);
    color: #b2b1b1;
    border-width: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: 0;
    opacity: 0;
  }

  select > option {
    background-color: #fff;
  }

  .item > img {
    position: absolute;
    right: 0.24rem;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 0.28rem;
    height: 0.15rem;
    z-index: 5;
  }

  .item-check > button {
    position: absolute;
    border:0.02rem transparent solid;
    border-image:linear-gradient(to right,#427DFF,#6ECAFF) 1 10;
    width: 1.55rem;
    height: 0.62rem;
    text-align: center;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    font-size: 0.26rem;
    color: #59A4FF;
    outline: none;
    background-color: rgba(255, 255, 255, 0);
  }




</style>



// WEBPACK FOOTER //
// src/components/Promotion/Zuzuche_Pro.vue